<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <!-- <div class="card-header bg-transparent pb-5">
           <div class="text-muted text-center mt-2 mb-3">
            <small>Sign up with</small>
          </div>
          <div class="btn-wrapper text-center">
            <a href="#" class="btn btn-neutral btn-icon">
              <span class="btn-inner--icon"
                ><img src="static/img/icons/common/github.svg"
              /></span>
              <span class="btn-inner--text">Github</span>
            </a>
            <a href="#" class="btn btn-neutral btn-icon">
              <span class="btn-inner--icon"
                ><img src="static/img/icons/common/google.svg"
              /></span>
              <span class="btn-inner--text">Google</span>
            </a>
          </div>
        </div> -->
        <form role="form" name="form" v-on:submit.prevent="handleRegister">
        <div class="card-header bg-transparent pb-5">
          <div class="text-center text-muted mb-4">
            {{$t($route.name+'.credentialAsk')}}<br>
            <small>{{$t($route.name+'.mandatoryFields')}}</small>
          </div>
            <!-- username -->
            <div class="form-group" :class="{ error: v$.model.username.$errors.length }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t($route.name+'.username')+' *'"
                type="text"
                :error="errorsArrayToSingleString(v$.model.username.$errors)"
                addon-left-icon="ni ni-circle-08"
                v-model="v$.model.username.$model"
              >
              </base-input>
                
            </div>

            <!-- email -->
            <div class="form-group" :class="{ error: v$.model.email.$errors.email }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t($route.name+'.email')+' *'"
                type="text"
                :error="errorsArrayToSingleString(v$.model.email.$errors)"
                addon-left-icon="ni ni-email-83"
                v-model="v$.model.email.$model"
              >
              </base-input>
                
            </div>

            <!-- password -->
            <div class="form-group" :class="{ error: v$.model.password.$errors.length }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t($route.name+'.password')+' *'"
                type="password"
                :error="errorsArrayToSingleString(v$.model.password.$errors)"
                addon-left-icon="ni ni-lock-circle-open"
                v-model="v$.model.password.$model"
              >
              </base-input>
                
            </div>

            <!-- confirmPassword -->
            <div class="form-group" :class="{ error: v$.model.confirmPassword.$errors.length }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t($route.name+'.confirmPassword')+' *'"
                :error="errorsArrayToSingleString(v$.model.confirmPassword.$errors)"
                type="password"
                addon-left-icon="ni ni-lock-circle-open"
                v-model="v$.model.confirmPassword.$model"
              >
              </base-input>
                
              <small
                >{{$t($route.name+'.passStrength')}}:
              <span v-bind:class="pass.color+' font-weight-700'">{{$t(pass.strength)}}</span></small>
            </div>
          </div>

          <!-- Personal data -->
          <div class="card-body px-lg-5 py-lg-5">
            <div class="text-center text-muted mb-4">
              {{$t($route.name+'.personalDataTitle')}}<br>
            </div>
            <!-- firstName -->
            <div class="form-group" :class="{ error: v$.model.firstName.$errors.length }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t($route.name+'.firstName')+' *'"
                type="text"
                :error="errorsArrayToSingleString(v$.model.firstName.$errors)"
                addon-left-icon="ni ni-circle-08"
                v-model="v$.model.firstName.$model"
              >
              </base-input>
                
            </div>

            <!-- lastName1 -->
            <div class="form-group" :class="{ error: v$.model.lastName1.$errors.length }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t($route.name+'.lastName1')+' *'"
                type="text"
                :error="errorsArrayToSingleString(v$.model.lastName1.$errors)"
                addon-left-icon="ni ni-circle-08"
                v-model="v$.model.lastName1.$model"
              >
              </base-input>
                
            </div>

            <!-- lastName2 -->
            <div class="form-group" :class="{ error: v$.model.lastName2.$errors.length }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t($route.name+'.lastName2')"
                type="text"
                :error="errorsArrayToSingleString(v$.model.lastName2.$errors)"
                addon-left-icon="ni ni-circle-08"
                v-model="v$.model.lastName2.$model"
              >
              </base-input>
                
            </div>

            <!-- nif -->
            <div class="form-group" :class="{ error: v$.model.nif.$errors.length }">
                <base-input
                  formClasses="input-group-alternative"
                  v-bind:placeholder="$t($route.name+'.nif')+' *'"
                  type="text"
                  :error="errorsArrayToSingleString(v$.model.nif.$errors)"
                  addon-left-icon="ni ni-badge"
                  v-model="v$.model.nif.$model"
                >
                </base-input>
                
            </div>


            <!-- phone -->
            <div class="form-group" :class="{ error: v$.model.phone.$errors.length }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t($route.name+'.phone')+' *'"
                type="text"
                :error="errorsArrayToSingleString(v$.model.phone.$errors)"
                addon-left-icon="ni ni-mobile-button"
                v-model="v$.model.phone.$model"
              >
              </base-input>
                
            </div>

            <!-- Searcher -->
            <div class="row">
              <div class="col">
                <span>{{$t($route.name+".userSearcher")}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <GMapAutocomplete 
                    class="input-group"
                    :placeholder="$t($route.name+'.registerGoogleAskAddressPlaceholder')"
                    @place_changed="setPlace"
                    :options="{ types: ['address']}"
                  >
                </GMapAutocomplete>
                <br>
              </div>
            </div>
            <!-- End of searcher -->

            <!-- address -->
            <div class="row">
              <div class="col">
                <div class="form-group" :class="{ error: v$.model.address.$errors.length }">
                  <base-input
                    formClasses="input-group-alternative"
                    v-bind:placeholder="$t($route.name+'.address')"
                    type="text"
                    :error="errorsArrayToSingleString(v$.model.address.$errors)"
                    addon-left-icon="ni ni-building"
                    v-model="v$.model.address.$model"
                  >
                  </base-input>
                    
                </div>
              </div>
              <div class="col-4">
                <div class="form-group" :class="{ error: v$.model.addressNum.$errors.length }">
                  <base-input
                    formClasses="input-group-alternative"
                    v-bind:placeholder="$t($route.name+'.addressNum')"
                    type="text"
                    :error="errorsArrayToSingleString(v$.model.addressNum.$errors)"
                    addon-left-icon="ni ni-building"
                    v-model="v$.model.addressNum.$model"
                  >
                  </base-input>
                    
                </div>
              </div>    
            </div>

            <!-- city -->
            <div class="form-group" :class="{ error: v$.model.city.$errors.length }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t($route.name+'.city')"
                type="text"
                :error="errorsArrayToSingleString(v$.model.city.$errors)"
                addon-left-icon="ni ni-square-pin"
                v-model="v$.model.city.$model"
              >
              </base-input>
                
            </div>

            <!-- postalCode -->
            <div class="form-group" :class="{ error: v$.model.postalCode.$errors.length }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t($route.name+'.postalCode')"
                type="text"
                :error="errorsArrayToSingleString(v$.model.postalCode.$errors)"
                addon-left-icon="ni ni-send"
                v-model="v$.model.postalCode.$model"
              >
              </base-input>
                
            </div>

            <!-- province -->
            <div class="form-group" :class="{ error: v$.model.province.$errors.length }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t($route.name+'.province')"
                type="text"
                :error="errorsArrayToSingleString(v$.model.province.$errors)"
                addon-left-icon="ni ni-map-big"
                v-model="v$.model.province.$model"
              >
              </base-input>
                
            </div>

            <!-- region -->
            <div class="form-group" :class="{ error: v$.model.region.$errors.length }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t($route.name+'.region')"
                type="text"
                :error="errorsArrayToSingleString(v$.model.region.$errors)"
                addon-left-icon="ni ni-compass-04"
                v-model="v$.model.region.$model"
              >
              </base-input>
                
            </div>

            <!-- country -->
            <div class="form-group" :class="{ error: v$.model.country.$errors.length }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t($route.name+'.country')"
                type="text"
                :error="errorsArrayToSingleString(v$.model.country.$errors)"
                addon-left-icon="ni ni-world-2"
                v-model="v$.model.country.$model"
              >
              </base-input>
                
            </div>

            <!-- payAccountNumber -->
            <!-- <div class="form-group" :class="{ error: v$.model.payAccountNumber.$errors.length }">
              <base-input
                formClasses="input-group-alternative"
                v-bind:placeholder="$t($route.name+'.payAccountNumber')"
                type="text"
                :error="errorsArrayToSingleString(v$.model.payAccountNumber.$errors)"
                addon-left-icon="ni ni-credit-card"
                v-model="v$.model.payAccountNumber.$model"
              >
              </base-input> -->
                
            

            <div class="row my-4">
              
              <div class="form-group" :class="{ error: v$.model.policyAgreement.$errors.length }">
                <div class="col">
                  <div class="row">
                    <div class="col-auto">
                      <base-checkbox 
                        class="custom-control-alternative"
                        @change="policyAgreementCheckbox()"
                      >
                      </base-checkbox>
                    </div>
                    <div class="col">
                      <span class="text-muted">{{$t($route.name+'.policyAgreementPrefix')}}<a @click.prevent="this.modals.modal1=true;" href="#">{{$t($route.name+'.policyAgreement')}}</a> *</span>
                    </div>
                  </div>
                </div>
                <!-- error message -->
                <div class="input-errors" v-for="(error, index) of v$.model.policyAgreement.$errors" :key="index">
                  <div class="error-msg" style="justify-content:center;">
                    <span style="color:red"><small>{{$t(error.$message)}}</small></span>
                  </div>
                </div> 
              </div>
              
            </div>
            <div class="text-center">
              <base-button 
                type="primary" 
                native-type="submit"
                class="my-4">
                {{ $t(this.$route.name+'.createAccount') }}
              </base-button>
            </div>
        </div>
      </form>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <a href="#" class="text-light">
            <small>{{$t($route.name+'.forgotPass')}}</small>
          </a>
        </div>
        <div class="col-6 text-right">
          <router-link to="/login" class="text-light">
            <small>{{$t($route.name+'.login')}}</small>
          </router-link>
        </div>
      </div>
    </div>
    <modal :show="modals.modal3"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-sm">
      <card type="secondary" shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-4 py-lg-5"
            class="border-0"
      >     
            <div v-if="allRequiredFieldSet==false">
              <span>{{ $t(this.$route.name+'.requiredFieldsMissing') }}</span>
              <ul>
                <div v-for="(error, index) of this.v$.model.$silentErrors" :key="index">
                  <small><li><b>{{$t($route.name+'.'+error.$property)}}:</b>   {{$t(error.$message)}}</li></small>
                </div>
              </ul>
            </div>
            <div v-else>
              {{ this.message }}
            </div>
            <base-button 
              type="primary"
              class="btn btn-block btn-warning"
              v-on:click="this.modals.modal3=false;this.forgotPassEmailSent=true"
              >
            {{ $t(this.$route.name+'.cancelButton') }}
            </base-button>
      </card>
  </modal>

  <modal :show="modals.modal1"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-lg">
      <card type="secondary" shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-4 py-lg-5"
            class="border-0"
      >     
        <privacy-policy
          :language="$i18n.locale"
        />    
            <base-button 
              type="primary"
              class="btn btn-block btn-warning"
              v-on:click="this.modals.modal1=false"
              >
            {{ $t(this.$route.name+'.cancelButton') }}
            </base-button>
      </card>
  </modal>
  </div>
</template>
<script>
import i18n from '@/contents/contents'
import useVuelidate from '@vuelidate/core';
import Modal from "@/components/Modal.vue";
import { required, minLength, maxLength, email, sameAs, numeric, helpers } from '@vuelidate/validators'
//import validateIBAN from './iban'
import PrivacyPolicy from './PrivacyPolicy.vue'

const passStrengthRegex = helpers.regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/)

export function validName(name) {
  let validNamePattern = new RegExp("^[a-zA-ZÀ-ÿ]+(?:[-'\\s][a-zA-Z]+)*$");
  if (validNamePattern.test(name)){
    return true;
  }
  return false;
}

export function validNif(nif) {
  let validNamePattern = new RegExp("([a-z]|[A-Z]|[0-9])[0-9]{7}([a-z]|[A-Z]|[0-9])");
  if (validNamePattern.test(nif)){
    return true;
  }
  return false;
}

/*export function validAccountNumber(num) {
  
  let iban = num;
  iban = iban.split(" ").join("");
  iban = iban.split("-").join("");
  if (validateIBAN(iban)){
    return true;
  }
  return false;
}*/

const pass_colors = {
  low: "text-danger",
  mid: "text-warning",
  high: "text-success"
};

export default {
  name: "register",
  setup () {
    return { v$: useVuelidate() }
  },
  mounted(){
    
  },
  components: {
    Modal,
    PrivacyPolicy,
  },
  methods : {
    handleRegister() {
      
      this.v$.$touch();
      this.message = '';
      this.submitted = true;
      
      /* Check if all required fields are already filled */
      if(this.v$.model.$invalid){
        this.allRequiredFieldSet = false;
        this.modals.modal3 = true;
      } else {
        this.model.language = i18n.global.locale;
        this.$store.dispatch('auth/register', this.model).then(
          () => {
            alert(this.$t(this.$route.name+'.userCreationSuccess'));
            this.$router.push('/login');
          },
          error => {
            this.message =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
            if(error.response.status==409){
              if(error.response.data.detail.includes("Duplicated id")){
                alert(this.$t(this.$route.name+'.userCreationFailedUsername'));
              }else if(error.response.data.detail.includes("Email")){
                alert(this.$t(this.$route.name+'.userCreationFailedEmail'));
              }else{
                alert(error.response.data.detail);
              }
            }
          }
        );
      }
    },
    setPlace(place){
      
      this.model.address = place.address_components[0].long_name;
      this.model.city = place.address_components[1].long_name;
      this.model.province = place.address_components[2].long_name;
      this.model.region = place.address_components[3].long_name;
      this.model.country = place.address_components[4].long_name;
      if(place.address_components.length == 6){
        this.model.postalCode = place.address_components[5].long_name;
      }
      
    },

    errorsArrayToSingleString(array){
      var str = "";
      if(array.length == 0) return
      array.forEach(item => str += item.$message+".\n")
      return str;
    },
    policyAgreementCheckbox(){
      if(this.v$.model.policyAgreement.$model ){
        this.v$.model.policyAgreement.$model = false;
      }else{
        this.v$.model.policyAgreement.$model = true;
      }
    }
  },
  computed: {
    password(){
      return this.model.password;
    },
  },
  watch: {
    password(password) {
      let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})");
      let mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");

      if (strongRegex.test(password)){
        this.pass.color = pass_colors.high;
        this.pass.strength = this.$route.name+'.passHighStrength';
      } else if (mediumRegex.test(password)){
        this.pass.color = pass_colors.mid;
        this.pass.strength = this.$route.name+'.passMidStrength';
      } else {
        this.pass.color = pass_colors.low;
        this.pass.strength = this.$route.name+'.passLowStrength';
      }
    },
  },
  validations() {
    return {
      model: {
        firstName: {
           required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
           textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 

        },
        lastName1: {
           required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
           textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        lastName2: {
           textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        nif: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidNif'), validNif), 
        },
        phone: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          numeric: helpers.withMessage(this.$t(this.$route.name+'.errorFieldNumeric'), numeric),
          min: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidLength', {length: 9}), minLength(9)),
        },
        username: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          min: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidLengthRange', {length_min: 5, length_max: 16}), minLength(5)),
          max: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidLengthRange', {length_min: 5, length_max: 16}), maxLength(16)),
        },
        password: {
            required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required), 
            min: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidLength',{length: 6}), minLength(6)),
            pass_str: helpers.withMessage(this.$t(this.$route.name+'.errorPassStrength'),passStrengthRegex),
        },
        email: {
            required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
            email: helpers.withMessage(this.$t(this.$route.name+'.errorFieldEmail'), email),
        },
        confirmPassword: {
          required_custom: helpers.withMessage(this.$t(this.$route.name+'.errorFieldRequired'), required),
          sameAsPassword: helpers.withMessage(this.$t(this.$route.name+'.errorPassConfirm'), sameAs(this.model.password)),
        },
        city: {
           textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        address: {
           textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        addressNum: {
          numeric: helpers.withMessage(this.$t(this.$route.name+'.errorFieldNumeric'), numeric),
        },
        postalCode: {
           textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidNumeric'), numeric), 
        },
        province: {
           textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        region: {
           textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        country: {
           textField_validation: helpers.withMessage(this.$t(this.$route.name+'.errorInvalidField'), validName), 
        },
        policyAgreement: {
           textField_validation: helpers.withMessage(
             this.$t(this.$route.name+'.errorPolicyAgreement'),
             function (val){
              return val;
           }), 
        },
        /*payAccountNumber: {
           textField_validation: helpers.withMessage(this.$route.name+'.errorInvalidAccountNum', validAccountNumber), 
        },*/
      
      },
    }
  },
  data() {
    return {
      model: {
        username: null,
        email: null,
        password: null,
        confirmPassword: null,
        firstName: null,
        lastName1: null,
        lastName2: null,
        phone: null,
        address: null,
        addressNum: null,
        city: null,
        region: null,
        province: null,
        postalCode: null,
        country: null,
        policyAgreement: false,
        language: null,
        //payAccountNumber: "",

      },
      pass: {
        strength: this.$route.name+'.passLowStrength',
        color: pass_colors.low,
      },
      modals: {
        modal1: false,
        modal3: false,
      },
      allRequiredFieldSet: false,
    };
  },
};
</script>
<style></style>
